import React from "react";
import MovieDetailBanner from "../../assets/img/flight-detail-banner.jpg";
import Grid from "@material-ui/core/Grid";
import { Button, Typography } from "@material-ui/core";
import { Favorite, ThumbUp,ArrowRightOutlined } from "@material-ui/icons";

export default function MovieDetail(props) {
  let item = props.data;

  return (
    <div>
      <div
        style={{
          background: `url(${MovieDetailBanner}) no-repeat`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          // height: "500px",
          width: "100%",        
        }}
      >
        <div style={{  background: 'linear-gradient(to right, black , transparent)'}}>
        <div className="container" >
          <Grid container>
            <Grid item xs="3" md="3" style={{ textAlign: "right" }}>
              <div style={{padding:'30px 0px'}}>
                <div className="movie-card">
                  <img src={item.Poster} />
                  <div className="movie-stats">
                    <Typography component="p" style={{textAlign:'center'}}> In Cinemas</Typography>
                  </div>
                </div>
              </div>
            </Grid>
            <Grid item xs="8" md="8" style={{textAlign:'left'}}>
            <div style={{padding:'30px 20px'}}> <div>
            <Typography variant="h4" className="mt-4" style={{fontWeight:'bold',color:'var(--darker)'}}>Movie Name</Typography>
            <Typography component="h5"  className="mt-3" style={{color:'var(--darker)'}}> <Favorite style={{color:'red'}}/> 69%  <Typography variant="span"> 9.8K ratings</Typography></Typography>
            </div>
            <div style={{backgroundColor:'var(--white)',borderRadius:'10px',padding:'15px'}}>
<Grid container>
  <Grid item xs="4" md="4">
    <Typography component="p">Add your rating and review</Typography>
    <Typography variant="span">Your ratings matter</Typography>
  </Grid>
  <Grid item xs="3" md="3">
    <Button>Rate Now</Button>
  </Grid>
</Grid>
            </div>
            </div>
            </Grid>
          </Grid>{" "}
        </div>
        </div>
      </div>
    </div>
  );
}
